import { TaoEditorBody } from "@/types/tao-routing";
import { tokenAxios } from "@/utils/axios";
import { useAppState } from "@/contexts/app-state";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Dispatch, SetStateAction } from "react";
import { buildApiUrl } from "@/utils/api";


interface UpdateTaoRequestArgs  {
    body: TaoEditorBody;
    taoId: number | undefined;
    practiceId: string;
    requestedUser: string;
}

interface MutationProps {
  onError?: Dispatch<SetStateAction<string>>
}


const postUpdateTao = async ({ body, practiceId, requestedUser, taoId }: UpdateTaoRequestArgs) => {
  if (!taoId) return Promise.reject("taoId is required");
    await tokenAxios().post(buildApiUrl("updateTaoRule"),
        body,
     {
        params: {
            practiceId,
            requestedUser,
            taoId,
        }
    });
};

export const useUpdateTao = ({ onError }: MutationProps, taoId?: number) => {
    const { context, loggedInUser } = useAppState();
    const queryClient = useQueryClient();
    const practiceId = context?.athena?.practiceId ?? "8967";
    const { isPending, isError, isSuccess, mutateAsync, error } = useMutation({
        mutationFn: postUpdateTao,
        onSettled: async () => {
          await queryClient.invalidateQueries({
            queryKey: ["tao-routing-rules"],
          });
      },
      onError: (err) => {
        if (onError) {
          onError(err.message);
        }
      }
      });

const updateTao = async (body: TaoEditorBody) => {
try {
  return await  mutateAsync({
            body,
            practiceId: practiceId,
            requestedUser: loggedInUser,
           taoId
        });
      } catch (error) {
        if (onError && error) {
          onError(JSON.stringify(error));
        }
        throw error;
      }
    };

        return {
            isPending,
            isError,
            isSuccess,
            updateTao,
            error
          };
};
